module.exports = __webpack_public_path__ + "static/3p-672875aec9ee872855ac31da4ac64005.png";